import { C } from '../../styles/tokens';

const P = {
  mic:     'M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3zM19 10a7 7 0 0 1-14 0M12 19v3M8 22h8',
  bolt:    'M13 2L3 14h9l-1 8 10-12h-9z',
  folder:  'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z',
  edit:    'M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4z',
  bell:    'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9m-4.27 13a2 2 0 0 1-3.46 0',
  check:   'M20 6L9 17l-5-5',
  x:       'M18 6L6 18M6 6l12 12',
  chevD:   'M6 9l6 6 6-6',
  chevR:   'M9 18l6-6-6-6',
  plus:    'M12 5v14M5 12h14',
  search:  'M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0',
  user:    'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  trend:   'M23 6l-9.5 9.5-5-5L1 18',
  chat:    'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  home:    'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  globe:   'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0 0c-2.5 0-4.5-4.5-4.5-10S9.5 2 12 2s4.5 4.5 4.5 10-2 10-4.5 10zM2 12h20',
  phone:   'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z',
  copy:    'M8 17H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2m-6 12h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2z',
  refresh: 'M23 4v6h-6M1 20v-6h6m15.2-5a9 9 0 1 1-2.2-4.9',
  play:    'M5 3l14 9-14 9V3z',
  pause:   'M6 4h4v16H6zM14 4h4v16h-4z',
};

const MusicPaths = () => (
  <>
    <path d="M9 18V5l12-2v13" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="6" cy="18" r="3" strokeWidth="1.75" />
    <circle cx="18" cy="16" r="3" strokeWidth="1.75" />
  </>
);

export function Ico({ n, size = 16, color = 'currentColor', style: s = undefined }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={s}>
      {n === 'music' ? <MusicPaths /> : <path d={P[n]} />}
    </svg>
  );
}

export function Logo({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none">
      <rect width="30" height="30" rx="8" fill="#2563EB" />
      <rect x="4"    y="13" width="3" height="5"  rx="1.5" fill="white" />
      <rect x="9.5"  y="10" width="3" height="11" rx="1.5" fill="white" />
      <rect x="15"   y="7"  width="3" height="17" rx="1.5" fill="white" opacity=".9" />
      <rect x="20.5" y="11" width="3" height="8"  rx="1.5" fill="white" opacity=".7" />
    </svg>
  );
}

export function WaveThumb() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <rect x="2"    y="10"  width="2.5" height="4"    rx="1.25" fill={C.p500} />
      <rect x="6.5"  y="7.5" width="2.5" height="9"    rx="1.25" fill={C.p500} />
      <rect x="11"   y="4.5" width="2.5" height="14"   rx="1.25" fill={C.p500} />
      <rect x="15.5" y="7"   width="2.5" height="9.5"  rx="1.25" fill={C.p500} opacity=".8" />
    </svg>
  );
}
